import { render } from "./PagamentoBoletoRejeitado.vue?vue&type=template&id=66df3a94"
import script from "./PagamentoBoletoRejeitado.vue?vue&type=script&lang=js"
export * from "./PagamentoBoletoRejeitado.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__